module.exports = __webpack_public_path__ + "media/icons-for-sprite/icon-arrow-right--white-6e947d43.svg";